<template>
    <div class="service-content">
        <div class="service">
            <h2>哪些场景 <br/>需要我们的服务</h2>
            <div class="menu-con">
                <div class="item">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logo/icon_01%402x.png" />
                    <div class="title">产品设计</div>
                    <div class="info">以深入的产品调研为基础，结合专业严谨的<br/>结构、传动设计，形成完善的产品方案。</div>
                </div>
                <div class="item">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logo/icon_02%402x.png" />
                    <div class="title">软件研发</div>
                    <div class="info">软件研发团队具有丰富的移动端程序设计和<br/>开发经验，为产品功能的实现提供强有力的<br/>技术支撑。</div>
                </div>
                <div class="item">
                    <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logo/icon_03%402x.png" />
                    <div class="title">运营维护</div>
                    <div class="info">互联网人心中共同的粘度。领导一个组织是令人难以置信<br/>的回报，同样令人谦卑。结构、传动设计，形成完善的产品方案。</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped lang="scss">
    .service-content{
        width: 100%;
        background: rgba(120, 27, 255, 0.02);
    }
    .service{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 51px;
        box-sizing: border-box;
        width: 1200px;
        margin:0 auto 0;
        h2{
            font-size: 34px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000B33;
            line-height: 51px;
            text-align: center;
        }
        .menu-con{
            display: flex;
            align-items: center;
            gap:23px;
            margin-top: 139px;
            .item{
                width: 395px;
                height: 274px;
                background: #fff;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap:14px;
                img{
                    width: 69px;
                    height: 76px;
                }
                .title{
                    font-size: 19px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000B33;
                    line-height: 25px;
                }
                .info{
                    font-size: 15px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000B33;
                    line-height: 25px;
                    text-align: center;
                }
            }
        }
    }
</style>